import { render, staticRenderFns } from "./LoansClosing.vue?vue&type=template&id=9a833234&scoped=true&"
import script from "./LoansClosing.vue?vue&type=script&lang=js&"
export * from "./LoansClosing.vue?vue&type=script&lang=js&"
import style0 from "./LoansClosing.vue?vue&type=style&index=0&id=9a833234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a833234",
  null
  
)

export default component.exports